import { render, staticRenderFns } from "./AffiliatedMedicalClinic.vue?vue&type=template&id=fc149ae8&scoped=true"
import script from "./AffiliatedMedicalClinic.vue?vue&type=script&lang=js"
export * from "./AffiliatedMedicalClinic.vue?vue&type=script&lang=js"
import style0 from "./AffiliatedMedicalClinic.vue?vue&type=style&index=0&id=fc149ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc149ae8",
  null
  
)

export default component.exports